import styled, { keyframes } from 'styled-components';

import { GREETING_MAX_WIDTH } from '@/utils/constants';

export const StyledHeading = styled.h3`
  font-size: 3rem;
  letter-spacing: -0.02em;
  @media (max-width: 48rem) {
    font-size: 1.6rem;
  }
`;

export const StyledSubHeading = styled.h3`
  font-size: 1.5rem;
  font-weight: 400;
  color: var(--gray-darker);
  @media (max-width: 48rem) {
    font-size: 1.2rem;
  }
`;

export const blink = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const Wrapper = styled.div`
  text-align: center;
  width: 100%;
  max-width: ${GREETING_MAX_WIDTH};
  margin: 0 auto 1rem;
  padding: 0;
  flex-shrink: 0;
`;

export const AnimatedText = styled.span`
  display: inline-block;
  // INFO: The Greeting wraps rather than clipping. A long user name is the only thing that reaches
  // GREETING_MAX_WIDTH, and CENTRED_LAYOUT_QUERY already reserves roughly 36px for the second line it
  // produces — see the derivation in src/utils/constants.ts. A 'white-space: nowrap' here used to make that
  // reservation describe something that could not happen: the box grew past the wrapper instead, and the
  // name was clipped by ContentWrapper's overflow-x. max-width caps the shrink-to-fit box so the text has
  // a width to wrap against, and overflow-wrap covers a name carrying no break opportunity of its own.
  max-width: 100%;
  overflow-wrap: anywhere;
`;

export const Cursor = styled.span`
  display: inline-block;
  font-weight: bold;
  animation: ${blink} 0.7s step-end infinite;
`;
